<app-layout>
  <div class="container mt-4">
    <app-card>
      <tabset>
        <tab
          i18n-heading="@@server"
          heading="Server"
          id="tab1"
        >
          <app-server-table></app-server-table>
        </tab>
        <tab
          i18n-heading="@@licenses"
          heading="Lizenzen"
        >
          <app-mandant-table></app-mandant-table>
        </tab>
      </tabset>
    </app-card>
  </div>
</app-layout>